import BRAND_LIST from "database/sell-gift-cards-brands.json";

export const getSearchResults = (query) => {
  if (!query) return [];

  return BRAND_LIST.filter(({ name }) =>
    name.toLowerCase().startsWith(query.toLowerCase())
  );
};

export const getSearchSuggestions = (query) => {
  if (!query) return [];

  const searchSuggestions = BRAND_LIST.filter(({ value }) =>
    value.toLowerCase().includes(query.toLowerCase())
  );

  searchSuggestions.sort(({ popularity: a }, { popularity: b }) => b - a);

  return searchSuggestions.slice(0, 3);
};
